import { MouseEvent } from 'react';

import { SkipLink } from 'approot/shared/layout/layout-skip-links.style';

export const ACTIVITY_BUILDER_SLIDE_NAVIGATION = 'slideNavigation';
export const ACTIVITY_BUILDER_VERSION_OPTIONS = 'versionOptions';

const ActivityBuilderDraftSkipLinks = () => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    el?.focus();
  };

  return (
    <>
      <SkipLink
        href={`#${ACTIVITY_BUILDER_VERSION_OPTIONS}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_VERSION_OPTIONS)}
      >
        <span>Skip to version options</span>
      </SkipLink>
      <SkipLink
        href={`#${ACTIVITY_BUILDER_SLIDE_NAVIGATION}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_SLIDE_NAVIGATION)}
      >
        <span>Skip to slide navigation</span>
      </SkipLink>
    </>
  );
};

export default ActivityBuilderDraftSkipLinks;
